import { makeStyles, Typography, Collapse } from "@material-ui/core";
import { useState } from "react";
import { UnrealizedRevenuesTab } from "./tabs/unrealizedRevenues";
import { PortfolioPowerRevenueTab } from "./tabs/portfolioPowerRevenue";
import { ActionButtonsGroup } from "../../components/buttonsGroup/ActionButtonsGroup";
import { HorizontalTabs } from "../../components/horizontalTabs";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(2.5)}px ${theme.spacing(4)}px`,
    height: "100%",
    boxSizing: "border-box",
  },
  title: {
    marginBottom: theme.spacing(1.6),
    fontWeight: 400,
  },
}));

export const UnrealizedPage = () => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);

  const getActiveTabComponent = () => {
    switch (tab) {
      case 0:
        return (
          <Collapse in={tab === 0}>
            <UnrealizedRevenuesTab />
          </Collapse>
        );
      case 1:
        return (
          <Collapse in={tab === 1}>
            <PortfolioPowerRevenueTab />
          </Collapse>
        );
      default:
        return (
          <Collapse in={tab === 0}>
            <UnrealizedRevenuesTab />
          </Collapse>
        );
    }
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="h2">
        Unrealized Power Revenues
      </Typography>

      <HorizontalTabs
        tab={tab}
        setTab={setTab}
        tabNames={["Unrealized Revenues", "Increase  Power Revenue"]}
        additionalComponent={tab === 1 ? <ActionButtonsGroup /> : null}
      />

      {getActiveTabComponent()}
    </div>
  );
};
